import React from "react";

import About from "../components/About";

const AboutPage = () => {
  return (
    <div className="col-12 bg-light p-0">
      <div className="col-md-8 col-sm-10 mx-auto pb-4 pt-4">
        <About />
      </div>
    </div>
  );
};

export default AboutPage;
